import Booklist from "./components/Booklist";
import Navbar from "./components/Navbar";
import Bookform from "./components/Bookform";
import {Provider} from "react-redux";
import store from "./redux/store";
import { useState } from "react";

function App() {  
  const [query , setQuery] = useState("");
  const handleInput = (e)=>{
    setQuery(e.target.value);    
  }
  
  return (
    <Provider store={store}> 
    <Navbar handleInput={handleInput} />
    <main className="py-12 2xl:px-6">
      <div className="container grid xl:grid-cols-[auto_350px] 2xl:grid-cols-[auto_400px] gap-4 2xl:gap-8">
        <Booklist query={query} />
        <Bookform />
      </div>
    </main>
    </Provider>
  );
}

export default App;
